import React from 'react';
import { registry } from './registry';
import type { InvitationData } from './types';
import { Watermark } from '../components/Watermark';

interface Props {
  templateId: string;
  data: InvitationData;
  /** Rendered when templateId has no matching React component yet. */
  fallback?: React.ReactNode;
  hasPartnerAttribution?: boolean;
  themeBgColor?: string | null;
}

export function TemplateRenderer({ templateId, data, fallback, hasPartnerAttribution, themeBgColor }: Props) {
  const entry = registry.get(templateId);

  if (!entry) {
    return (
      fallback ?? (
        <div className="flex items-center justify-center h-64 text-stone-400 text-sm bg-stone-50 rounded-2xl border border-stone-200">
          No preview available for this template.
        </div>
      )
    );
  }

  const Component = entry.component;
  return (
    <div className="relative flex flex-col min-h-screen w-full" style={themeBgColor ? { backgroundColor: themeBgColor } : undefined}>
      <div className="flex-grow w-full">
        <Component data={data} />
      </div>
      <Watermark isPremium={data.isPremium} hasPartnerAttribution={hasPartnerAttribution} themeBgColor={themeBgColor} />
    </div>
  );
}
